/*
 * Auto-sliding product images — used by both the product tiles and the
 * product page gallery.
 *
 * Markup contract:
 *   <div data-slides data-interval="3000">
 *     <img class="bbs-slide is-active"> <img class="bbs-slide"> …
 *   </div>
 * Optional thumbnails elsewhere on the page:
 *   <div data-slides-thumbs="<id of the slides container>">
 *     <button data-slide-to="0"> …
 *
 * Three things this is careful about:
 *   - Nothing animates off screen. A collection page can hold thirty tiles,
 *     and thirty timers ticking behind the viewport is wasted battery.
 *   - Each container starts at a slightly different point in its cycle, so a
 *     grid does not flip over all at once, which reads as a glitch.
 *   - Any deliberate interaction stops the autoplay for good. Shoppers who
 *     pick an image are trying to look at it, not race a timer.
 */
(function () {
  'use strict';

  var calm = false;
  try {
    calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function setup(root) {
    // Two timers on one container would make it flicker, so only ever set up once.
    if (root.dataset.slidesReady === '1') return;
    root.dataset.slidesReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.bbs-slide'));
    if (slides.length < 2) return;

    var interval = Math.max(1200, parseInt(root.dataset.interval, 10) || 3000);
    var thumbs = root.id
      ? Array.prototype.slice.call(
          document.querySelectorAll('[data-slides-thumbs="' + root.id + '"] [data-slide-to]'))
      : [];

    var dots = Array.prototype.slice.call(root.querySelectorAll('.bbs-dots span'));

    var at = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (at < 0) at = 0;
    var timer = null;
    var stopped = calm;

    function show(i) {
      at = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === at); });
      thumbs.forEach(function (t, n) { t.classList.toggle('pdp-thumb-active', n === at); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === at); });
    }

    function play() {
      if (stopped || timer) return;
      timer = setInterval(function () { show(at + 1); }, interval);
    }
    function pause() { clearInterval(timer); timer = null; }

    /** A click, a swipe or a keypress means the shopper is driving now. */
    function takeOver(i) {
      stopped = true;
      pause();
      if (typeof i === 'number') show(i);
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function (e) { e.preventDefault(); takeOver(n); });
    });

    // Swipe on the image itself. Horizontal only, so a vertical page scroll
    // that starts on the image is never mistaken for a swipe.
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      takeOver(at + (dx < 0 ? 1 : -1));
    }, { passive: true });

    show(at);

    if (stopped) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? play() : pause(); });
      }, { threshold: 0.35 }).observe(root);
    } else {
      play();
    }

    // Offset the first tick so neighbouring tiles drift apart instead of
    // changing in lockstep.
    var skew = Math.random() * interval * 0.8;
    setTimeout(function () { if (!stopped && timer) show(at + 1); }, skew);

    document.addEventListener('visibilitychange', function () {
      document.hidden ? pause() : play();
    });
  }

  function init() {
    document.querySelectorAll('[data-slides]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
